module.exports = __webpack_public_path__ + "static/media/cards-arrow.7cf8ddb4.svg";